import React, { useEffect, useState } from "react";
import { Input, Label, FormGroup, Row, Col, Table, Button } from "reactstrap";
import api from "../../api";

const gameFilters = [
  "Player Ban",
  "Player Unban",
  "Admin email update",
  "Admin password reset",
  "Map Rankings",
  "Pokemon rankings",
  "Trainer Rankings",
  "Color Box",
  "Coins Gift Received",
  "Coins Gift Sent",
  "Money Gift Sent",
  "Money Gift Recieved",
  "Email upated",
  "Auction House",
  "Reported Message",
];

const AdminLogs = () => {
  const [logType, setLogType] = useState("login");
  const [filterValue, setFilterValue] = useState("");
  const [logs, setLogs] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [loading, setLoading] = useState(false);

  const fetchLogs = async () => {
    if (!filterValue) return;
    setLoading(true);
    try {
      const response = await api.get("/v1/admin/logs", {
        params: {
          log_type: logType,
          filter_value: filterValue,
        },
        withCredentials: true,
      });
      setLogs(response.data.results || []);
    } catch (err) {
      console.error("Error fetching logs:", err);
    } finally {
      setLoading(false);
    }
  };

  const filteredLogs = logs.filter((log) =>
    Object.values(log).some((val) =>
      val?.toString().toLowerCase().includes(searchTerm.toLowerCase()),
    ),
  );

  const formatEpochTime = (epoch) => {
    if (!epoch) return "N/A";
    const date = new Date(
      epoch.toString().length === 10 ? epoch * 1000 : Number(epoch),
    );
    return date.toLocaleString();
  };

  return (
    <>
      <Row className="mb-3">
        <Col md={3}>
          <FormGroup>
            <Label for="logType">Log Type</Label>
            <Input
              type="select"
              value={logType}
              onChange={(e) => {
                setLogType(e.target.value);
                setLogs([]);
                setFilterValue("");
              }}
            >
              <option value="login">Login Logs</option>
              <option value="game">Game Logs</option>
            </Input>
          </FormGroup>
        </Col>
        <Col md={4}>
          <FormGroup>
            <Label for="filterValue">
              {logType === "login" ? "Username" : "Category Filter"}
            </Label>
            {logType === "login" ? (
              <Input
                type="text"
                placeholder="Enter username"
                value={filterValue}
                onChange={(e) => setFilterValue(e.target.value)}
              />
            ) : (
              <Input
                type="select"
                value={filterValue}
                onChange={(e) => setFilterValue(e.target.value)}
              >
                <option value="">-- Select a category --</option>
                {gameFilters.map((val) => (
                  <option key={val} value={val}>
                    {val}
                  </option>
                ))}
              </Input>
            )}
          </FormGroup>
        </Col>
        <Col md={2} className="d-flex align-items-end">
          <Button color="primary" onClick={fetchLogs}>
            Fetch Logs
          </Button>
        </Col>
        <Col md={3}>
          <FormGroup>
            <Label>Search Results</Label>
            <Input
              type="text"
              placeholder="Search in logs..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </FormGroup>
        </Col>
      </Row>

      {loading ? (
        <p>Loading logs...</p>
      ) : (
        <Table striped responsive className="align-middle">
          <thead>
            <tr>
              <th>ID</th>
              <th>When</th>
              <th>Who</th>
              <th>To</th>
              <th>Info</th>
              <th>What</th>
            </tr>
          </thead>
          <tbody>
            {filteredLogs.length === 0 ? (
              <tr>
                <td colSpan="6" className="text-center text-muted">
                  No logs available.
                </td>
              </tr>
            ) : (
              filteredLogs.map((log) => (
                <tr key={log.id}>
                  <td>{log.id}</td>
                  <td>{formatEpochTime(log.when)}</td>
                  <td>{log.who}</td>
                  <td>{log.to}</td>
                  <td>{log.info}</td>
                  <td>{log.what}</td>
                </tr>
              ))
            )}
          </tbody>
        </Table>
      )}
    </>
  );
};

export default AdminLogs;
